var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZupeeExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8079_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62041 16.1863L4.54688 16.2598L4.8305 20.1676H19.1695L19.4637 16.1863H4.62041Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4532 7.7403L19.1695 3.83252H4.8305L4.54688 7.81383H19.3901L19.4532 7.7403Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6795 23.1297C11.1356 20.4661 9.82478 18.0197 7.90831 16.0915C5.98156 14.1788 3.53963 12.8684 0.880615 12.3203V11.6795C3.5411 11.1355 5.98413 9.82449 7.90831 7.90831C9.82449 5.98413 11.1355 3.5411 11.6795 0.880615H12.3203C12.8684 3.53963 14.1788 5.98156 16.0915 7.90831C18.0197 9.82478 20.4661 11.1356 23.1297 11.6795V12.3203C20.4635 12.8568 18.0151 14.1689 16.092 16.092C14.1689 18.0151 12.8568 20.4635 12.3203 23.1297H11.6795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56787 16.2492L16.5433 4.27371L18.4762 4.23169L19.4426 7.76129L7.64577 19.5582L5.59734 19.8313L4.56787 16.2492Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5605 11.3329C20.8521 10.8462 18.3566 9.5453 16.4067 7.6037C14.4585 5.65865 13.1565 3.16091 12.6775 0.449951L11.3329 0.449951C10.8488 3.15914 9.54748 5.65541 7.6037 7.6037C5.65541 9.54748 3.15914 10.8488 0.449951 11.3329L0.449951 12.6775C3.15966 13.1535 5.65726 14.4519 7.6037 16.3962C9.54718 18.3489 10.8482 20.8484 11.3329 23.5605H12.6775C13.1511 20.847 14.4504 18.3458 16.3981 16.3981C18.3458 14.4504 20.847 13.1511 23.5605 12.6775V11.3329ZM15.8079 15.7974C13.9277 17.6613 12.61 20.0166 12.0052 22.594C11.3987 20.0196 10.0853 17.6656 8.21298 15.7974C6.34221 13.923 3.98429 12.6094 1.40589 12.0052C3.98267 11.3968 6.3395 10.0838 8.21298 8.21298C10.0838 6.3395 11.3968 3.98267 12.0052 1.40589C12.6094 3.98429 13.923 6.34221 15.7974 8.21298C17.6656 10.0853 20.0196 11.3987 22.594 12.0052C20.0177 12.607 17.6626 13.9211 15.7974 15.7974H15.8079Z",
    fill: "#4611A7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4372 22.6699C21.0649 22.6699 23.195 20.5397 23.195 17.9121C23.195 15.2844 21.0649 13.1543 18.4372 13.1543C15.8096 13.1543 13.6794 15.2844 13.6794 17.9121C13.6794 20.5397 15.8096 22.6699 18.4372 22.6699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4372 23.2992C15.4667 23.2992 13.05 20.8825 13.05 17.912C13.05 14.9416 15.4667 12.5249 18.4372 12.5249C21.4077 12.5249 23.8243 14.9416 23.8243 17.912C23.8243 20.8825 21.4077 23.2992 18.4372 23.2992ZM18.4372 13.7836C16.159 13.7836 14.3087 15.6338 14.3087 17.912C14.3087 20.1902 16.159 22.0405 18.4372 22.0405C20.7154 22.0405 22.5656 20.1902 22.5656 17.912C22.5656 15.6338 20.7154 13.7836 18.4372 13.7836Z",
    fill: "#4611A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7974 16.8927L17.8169 20.7093L18.537 20.7056L19.2571 20.7019L19.2376 16.8853L17.7974 16.8927Z",
    fill: "#4611A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7934 16.1294L19.2336 16.1221L19.2286 15.1283L17.7883 15.1357L17.7934 16.1294Z",
    fill: "#4611A7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8079_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1,
    height: 23.1,
    fill: "white",
    transform: "translate(0.449951 0.449951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZupeeExclamationIcon);
export default __webpack_public_path__ + "static/media/zupee-exclamation-icon.c85f3b28dab889843e375b6dd4f4726d.svg";
export { ForwardRef as ReactComponent };